<template>
    <div class="min-vh-100 d-flex align-items-center mx-auto" :class="props.class">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-md-6 offset-xl-2 offset-md-1 order-md-2 mb-5 mb-md-0">
                    <div class="text-center">
                        <img :src="getIllustration()" alt="Confused person in front of a laptop" class="img-fluid" />
                    </div>
                </div>
                <div class="col-12 col-md-5 col-xl-4 order-md-1 my-5">
                    <div class="text-center">
                        <h4
                            v-if="isNonNullable(props.supertitle)"
                            v-dompurify-html="te(props.supertitle) ? t(props.supertitle) : props.supertitle"
                            class="text-uppercase text-muted mb-4" />

                        <h1 v-dompurify-html="te(props.title) ? t(props.title) : props.title" class="display-4 mb-3" />

                        <p
                            v-dompurify-html="te(props.subtitle) ? t(props.subtitle) : props.subtitle"
                            class="text-secondary mb-5 pt-1" />

                        <slot name="buttons">
                            <b-button v-if="!props.hideButtons" variant="primary" @click="returnToStart">{{
                                t('errors.returnToStart')
                            }}</b-button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <img src="@/assets/img/logos/logo-blue-dark-with-subtext.svg" alt="Sagacity Logo" class="logo" /> -->
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import type { TranslationKey } from '@/i18n';
import { useI18n } from 'vue-i18n';
import { isNonNullable } from '@/utils/nullability-helpers';

// import evaluationError from '@/assets/img/illustrations/evaluation-error.svg';
import womanPointingFinger from '@/assets/img/illustrations/woman-pointing-finger.svg';
// import submissionComplete from '@/assets/img/illustrations/submission-complete.svg';
// import getStarted from '@/assets/img/illustrations/get-started.svg';
// import reportAwaited from '@/assets/img/illustrations/report-awaited.svg';

interface ErrorLayoutProps {
    supertitle?: TranslationKey | string;
    title: TranslationKey | string;
    subtitle: TranslationKey | string;
    class?: string;
    illustration?: string;
    hideButtons?: boolean;
}

const props = withDefaults(defineProps<ErrorLayoutProps>(), {
    supertitle: '',
    illustration: 'woman-pointing-finger',
    illustrationAltText: 'Confused person in front of a laptop',
    class: '',
    hideButtons: false,
});

const { t, te } = useI18n();

const router = useRouter();
const { isInstructor } = useAuthStore();

async function returnToStart() {
    if (isInstructor.value) {
        router.push('/admin');
    } else {
        router.push('/');
    }
}

function getIllustration() {
    // if (props.illustration === 'evaluation-error') {
    //     return evaluationError;
    // } else if (props.illustration === 'submission-complete') {
    //     return submissionComplete;
    // } else if (props.illustration === 'get-started') {
    //     return getStarted;
    // } else if (props.illustration === 'report-awaited') {
    //     return reportAwaited;
    // }
    return womanPointingFinger;
}
</script>

<style scoped lang="scss">
.logo {
    position: absolute;
    width: 100px;
    bottom: 20px;
    left: 36px;
}
</style>
